module.exports = __webpack_public_path__ + "static/img/IMG_20150611_162432.8bedcae9.jpg";